import { Component } from '@angular/core';

@Component({
  selector: 'fl-modal-title',
  template: `
    <h1><ng-content></ng-content></h1>
    <div>- - - - - - - - - some dashed line - - - - - - - - - - or whatever - - - - -</div>
  `,
  styleUrls: ['./modal-title.component.scss'],
})
export class ModalTitleComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/app/@shared/ui/modal/modal-title.component.ts